import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { reInitiateKyc } from '../profileEndpoints'
import { profileKeys } from '../profileQueryKeys'

export function useReInitiateKycMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: reInitiateKyc,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: profileKeys.kycDetails() })
      qc.invalidateQueries({ queryKey: profileKeys.accountStatus() })
    },
  })
}
